// Prohodí velikost obrázku v URL (related/big/orig/detail)
// Nové podepsané URL (od 24. 6. 2026) mají query parametry x/y/q/sg —
// po úpravě cesty by řídily výstup, proto se z query nechává jen ts=
window.myImageSize = function (url, size) {
    if (!url) {
        return url;
    }

    const parts = url.split("?");
    const base = parts[0].replace(/\/(related|big|orig|detail|category)\//, "/" + size + "/");
    const query = parts[1] || "";

    // Stará URL bez podpisu — query (cache hash) se nechává beze změny
    if (query.indexOf("sg=") === -1) {
        return query ? base + "?" + query : base;
    }

    const ts = query.split("&").filter(function (param) { return param.indexOf("ts=") === 0; })[0];
    return ts ? base + "?" + ts : base;
};


// Fixní CTA tlačítko "Vyžádat nabídku pro firmy a obce" — mobilní sticky button
// Seznam kategorií kde se zobrazí (body class id-XXXX)
// 1049 = Nábytek do kavárny a restaurace, 1052 = Restaurační židle, 1055 = Restaurační stoly
// 1125 = Restaurační barové židle, 1197 = Stohovatelné židle, 2087 = Stolové desky
// 2090 = Stolové podnože, 2162 = Kulturní sály
const firmyBtnCategories = [1049, 1052, 1055, 1125, 1197, 2087, 2090, 2162];

// Doplní blok recenzí zálohou ze shopDataLayer.homepage.reviews.backup do počtu count.
// Přeskakuje autory, kteří už v bloku jsou, aby se recenze neopakovala.
window.fillBackupReviews = function ($inner, count) {
    const backup = shopDataLayer.homepage.reviews.backup || [];
    const shownNames = $inner.find(".vote-name span").map(function () {
        return $(this).text().trim();
    }).get();
    let missing = count - $inner.children(".vote-wrap").length;

    $.each(backup, function (index, review) {
        if (missing <= 0) {
            return false;
        }
        if (shownNames.indexOf(review.name) !== -1) {
            return;
        }

        const $stars = $("<span class='stars'></span>");
        for (let i = 0; i < 5; i++) {
            $stars.append("<span class='star star-on' aria-hidden='true'></span>");
        }

        $("<div class='vote-wrap vote-wrap--backup'></div>")
            .append(
                $("<div class='vote-header'></div>").append(
                    $("<span class='vote-summary'></span>").append(
                        $("<span class='vote-rating'></span>").append($stars)
                    )
                )
            )
            .append($("<div class='vote-content'></div>").text(review.text))
            .append($("<span class='vote-name'></span>").append($("<span></span>").text(review.name)))
            .appendTo($inner);

        missing--;
    });
};

function initFixedFirmyBtn() {
    if ($(".firmy-btn-fixed").length > 0) return;
    if (!$(".type-category").length) return;

    const match = firmyBtnCategories.some(function (id) {
        return $("body").hasClass("id-" + id);
    });
    if (!match) return;

    $("<a href='#' class='firmy-btn-fixed' data-modal-open='firmy'>" +
        "<span>" + shopDataLayer.header.firmy.text + "</span>" +
        "</a>").appendTo("body");
}


$(document).ready(function () {
    $.colorbox.settings.transition = "none";
    if ($("#header").length) {
        $("#header .search input[type='search']").attr("placeholder", shopDataLayer.header.search.placeholder);
    }

    $("#signature")
        .html(
            '<a href=\'https://www.shoptet.cz/?utm_source=footer&utm_medium=link&utm_campaign=create_by_shoptet\' target=\'_blank\' class=\'shoptet-link\'><img src="https://cdn.myshoptet.com/prj/dist/master/cms/img/common/logo/shoptetLogo.svg" width="17" height="17" alt="Shoptet" class="shoptet-logo">Vytvořil Shoptet,</a> <a href="https://www.hellodesign.cz/" target="_blank" class=\'hello-link\'>Hellodesign.cz</a> & <a href="https://jankolonicny.cz/" target="_blank" class=\'jk-link\'><img src="/user/documents/upload/kodovani/jk_2.svg" alt="Logo jankolonicny.cz" width=\'24\'></a>',
        )
        .attr("style", "display: inline-flex !important");

    if ($(window).width() > 767) {
        if ($("#header").length) {
            $("<a href='#' class='mylogin firmy-btn' data-modal-open='firmy'><span>" + shopDataLayer.header.firmy.text + "</span></a>").prependTo("#header .navigation-buttons");
            $("<a href='/login/' class='mylogin'><span>" + shopDataLayer.header.login.text + "</span></a>").prependTo("#header .navigation-buttons");
            $(".header-top").css("opacity", "1");
            $("<span class='mycart-text'>" + shopDataLayer.header.cart.text + "</span>").appendTo("#header .cart-count");
        }
    } else {
        $("#header .cart-count").removeClass("toggle-window").removeAttr("data-redirect");
        if ($("#navigation .menu-level-1").length && $(".nav-firmy-btn").length === 0) {
            const $firmyItem = $("<li class='nav-firmy-btn'><a href='#' data-modal-open='firmy'>" + shopDataLayer.header.firmy.text + "</a></li>");
            const $contactItem = $("#navigation .menu-level-1 > .nav-contact-item");

            // Nad kontaktní osobu, jinak nad Blog/Kontakty, jinak na konec
            if ($contactItem.length) {
                $firmyItem.insertBefore($contactItem);
            } else {
                window.myInsertIntoMobileMenu($firmyItem);
            }
        }
    }
    if ($(".in-index").length) {
        if ($(".reviews").length == 0) {
            $(
                "<div class='reviews container'><h2 class='reviews-title'>" +
                shopDataLayer.homepage.reviews.title +
                "</h2><div class='reviews-inner'></div><div class='btn-holder'><a href='" +
                shopDataLayer.homepage.reviews.readMore.link +
                "' class='my-btn'>" +
                shopDataLayer.homepage.reviews.readMore.text +
                "</a><a href='" +
                shopDataLayer.homepage.reviews.addReview.link +
                "' class='my-btn main-btn'>" +
                shopDataLayer.homepage.reviews.addReview.text +
                "</a></div></div>",
            ).insertAfter(".benefitBanner");
        }
        $(".products-block").each(function (index) {
            $(this)
                .addClass("swiper-wrapper")
                .wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
            $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
            $($(this).find(".product")).addClass("swiper-slide");
            const productSwiper = new Swiper(".myproducts-swiper-" + index, {
                pagination: {
                    el: ".myswiper-navi-" + index + " .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".myswiper-navi-" + index + " .myswiper-next",
                    prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
                },
                spaceBetween: 24,
                slidesPerView: "auto",
                preventClicks: false,
                preventClicksPropagation: false,

                breakpoints: {
                    320: {
                        spaceBetween: 15,
                        slidesOffsetAfter: 10,
                        slidesOffsetBefore: 10,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesOffsetAfter: 0,
                        slidesOffsetBefore: 0,
                    },
                },
            });
        });
        setTimeout(function () {
            if ($(".next-to-carousel-banners").length) {
                $("<div class='categories-wrapper'></div>").appendTo(".next-to-carousel-banners");
                $(".next-to-carousel-banners .banner-wrapper:not(:has(h2))").appendTo(".categories-wrapper");
            }
        }, 0);

        $(".whole-wrap").last().addClass("last");
    }

    if ($(".type-category").length) {
        $(".subcategories").prependTo(".category-content-wrapper");
        if ($(".category-perex p").length > 1 && $(".read-more").length == 0) {
            $(".category-perex").addClass("not-all");
            $("<span class='read-more'>" + shopDataLayer.category.readMore + "</span>").appendTo(".category-perex p:first");
            $(".category-perex p:not(:first-child)").hide();
        }
        $(document).on("click", "li:has(>.listSorting__control--current)", function () {
            $(".listSorting__controls").toggleClass("active");
        });
        $(".filter-section:has(.filter-label.active)").addClass("active");
        $(".load-products").html(shopDataLayer.category.loadMore);
    }

    if ($(".type-detail").length) {
        $(".p-detail-inner-header").prependTo(".p-info-wrapper");
        $(".p-detail-info").prependTo(".p-info-wrapper");
        $(".breadcrumbs").prependTo(".p-info-wrapper");
        $(".p-detail-info .flags").appendTo(".p-image-wrapper .p-image");

        // Slevový flag na obrázek (stejný pattern jako v kategorii)
        const $detailImage = $(".p-image-wrapper .p-image");
        const $detailSave = $detailImage.find(".flag-discount .price-save");
        if ($detailSave.length) {
            if ($detailImage.find(".flags").length === 0) {
                $("<div class='flags'></div>").appendTo($detailImage);
            }
            $detailSave.addClass("flag flag-save").appendTo($detailImage.find(".flags"));
        }

        // Mixed-sale: skrýt slevový flag a červenou cenu, pokud ne všechny varianty
        // mají slevu (default view) nebo aktuálně vybraná varianta slevu nemá.
        // Detekce: viditelný .price-save > .parameter-dependent má class .empty,
        // nebo je výchozí pohled a existuje varianta s .empty.
        function updateMixedSaleState() {
            const $priceSave = $(".p-detail-inner .p-final-price-wrapper .price-save");
            if (!$priceSave.length) return;

            const $visible = $priceSave.children(".parameter-dependent").not(".no-display").first();
            const isDefaultView = $visible.hasClass("default-variant");

            const hideSale = isDefaultView
                ? $priceSave.children(".parameter-dependent.empty").length > 0
                : $visible.hasClass("empty");

            $(".p-detail-inner").toggleClass("mixed-sale", hideSale);
        }

        updateMixedSaleState();
        // ShoptetVariantAvailable / Unavailable firne POSLEDNÍ v sekvenci variant eventů,
        // až po aktualizaci DOMu — VariantChange eventy firnou před DOM update.
        document.addEventListener("ShoptetVariantAvailable", updateMixedSaleState);
        document.addEventListener("ShoptetVariantUnavailable", updateMixedSaleState);
        document.addEventListener("ShoptetSelectedParametersReset", updateMixedSaleState);

        $(".p-final-price-wrapper").insertBefore(".add-to-cart");
        $(".p-info-wrapper .availability-value").wrap("<div class='shipping-info'></div>");
        $(".p-info-wrapper tr:has(.shipping-options)").hide();
        $(".shipping-options").appendTo(".shipping-info");
        $(".shipping-info").insertBefore(".add-to-cart");
        $("p[data-testid='productCardDescr']").prependTo(".social-buttons-wrapper .link-icons");
        $("p[data-testid='productCardDescr'] a").html(shopDataLayer.productDetail.longDecsriptionLinkText);
        $(".link-icon.chat").html(shopDataLayer.productDetail.askText);
        $(".link-icon.watchdog").html(shopDataLayer.productDetail.watchdogText);

        if ($(".specific-banner").length == 0 && $(".p-image-wrapper .flag-specificky-rozmer").length) {
            $("<div class='specific-banner'><img src='" + shopDataLayer.productDetail.specificBanner.image + "'><div class='specific-banner__inner'><div class='specific-banner__title'>" + shopDataLayer.productDetail.specificBanner.title + "</div><div class='specific-banner__subtitle'>" + shopDataLayer.productDetail.specificBanner.subtitle + "</div><a href='' class='specific-banner__button'>" + shopDataLayer.productDetail.specificBanner.button.text + "</a></div></div>").insertBefore(".social-buttons-wrapper");
        }


        if ($(".reviews").length == 0) {
            $(
                "<div class='reviews container'><h2 class='reviews-title'>" +
                shopDataLayer.productDetail.reviewsTitle +
                "</h2><div class='reviews-inner'></div><div class='btn-holder'><a href='" +
                shopDataLayer.homepage.reviews.readMore.link +
                "' class='my-btn'>" +
                shopDataLayer.homepage.reviews.readMore.text +
                "</a><a href='" +
                shopDataLayer.homepage.reviews.addReview.link +
                "' class='my-btn main-btn'>" +
                shopDataLayer.homepage.reviews.addReview.text +
                "</a></div></div>",
            ).insertAfter("#tab-content");
        }

        // Galerie variant — záložky s odstíny / látkami / nálepkami atd.
        // JSON je klíčovaný podle ID parametru varianty; viz docs/variant-galleries.md
        if ($("[data-parameter-id]").length) {
            // __DATA_VERSION__ je hash obsahu src/data/**, injektovaný esbuildem.
            // Změna JSONu = nový hash = invalidace localStorage cache na klientech.
            const dataVersion = __DATA_VERSION__;

            const storageKey = "variantGalleries_data";
            const timestampKey = "variantGalleries_timestamp";
            const versionKey = "variantGalleries_version";
            const currentTime = Date.now();
            const twentyFourHours = 24 * 60 * 60 * 1000;

            // Sestaví záložky z JSONu na základě variantních parametrů produktu.
            // Parametry se stejným tabGroup se sloučí do jedné záložky (sekce nad
            // sebou, řazené dle tabGroupOrder), ostatní mají vlastní záložku.
            function loadVariantGalleries(data) {
                if (!data) return;

                // 1) Parametry přítomné na produktu (DOM pořadí) s configem v JSONu
                const present = [];
                $("[data-parameter-id]").each(function () {
                    const paramId = String($(this).attr("data-parameter-id"));
                    const cfg = data[paramId];
                    if (!cfg || !cfg.values) return;

                    const values = [];
                    $(this).find("input[type='radio']").each(function () {
                        const val = $(this).val();
                        if (val && cfg.values[val]) {
                            values.push($.extend({ id: val }, cfg.values[val]));
                        }
                    });

                    if (values.length) {
                        present.push({ paramId: paramId, cfg: cfg, values: values });
                    }
                });

                if (!present.length) return;

                // 2) Seskupení podle tabGroup (zachová DOM pořadí prvního výskytu)
                const tabs = [];
                const groupIndex = {};
                present.forEach(function (entry) {
                    const group = entry.cfg.tabGroup;
                    if (group && groupIndex[group] !== undefined) {
                        tabs[groupIndex[group]].members.push(entry);
                    } else {
                        if (group) groupIndex[group] = tabs.length;
                        tabs.push({ members: [entry] });
                    }
                });

                // 3) Vykreslení záložek
                tabs.forEach(function (tab) {
                    // Řazení sekcí uvnitř sloučené záložky podle tabGroupOrder
                    tab.members.sort(function (a, b) {
                        return (a.cfg.tabGroupOrder || 0) - (b.cfg.tabGroupOrder || 0);
                    });

                    // Název: spojení tabLabel členů " / " — např. "Barvy / Látky"
                    const title = tab.members.map(function (m) {
                        return m.cfg.tabLabel || "";
                    }).join(" / ");

                    const tabId = "variant-gallery-" + tab.members.map(function (m) {
                        return m.paramId;
                    }).join("-");

                    $("<li class='shp-tab' data-testid='tabVariantGallery'>" +
                        "<a href='#" + tabId + "' class='shp-tab-link' role='tab' data-toggle='tab'>" + title + "</a>" +
                        "</li>").appendTo("#p-detail-tabs");

                    let paneHtml = "<div id='" + tabId + "' class='tab-pane fade' role='tabpanel'>";
                    tab.members.forEach(function (m) {
                        paneHtml += "<div class='decor-section'>" +
                            "<h2 class='decors-title'>" + (m.cfg.sectionTitle || "") + "</h2>" +
                            "<div class='decors-inner'>";
                        m.values.forEach(function (v) {
                            paneHtml += "<div class='decor'>" +
                                "<div class='decor-image'><img src='" + v.image_path + "' alt='" + v.name + "'></div>" +
                                "<div class='decor-name'>" + v.name + "</div>" +
                                "</div>";
                        });
                        paneHtml += "</div></div>";
                    });
                    paneHtml += "</div>";
                    $("#tab-content").append(paneHtml);

                    // Odkazy v krátkém popisu mířící na tuhle záložku → přepnutí tabu
                    $(".p-short-description a[href='#" + tabId + "']").attr({
                        "data-toggle": "tab",
                        "data-external": "1",
                        "data-force-scroll": "true",
                    });
                });
            }

            // localStorage cache (24 h + version hash)
            const storedData = localStorage.getItem(storageKey);
            const storedTimestamp = localStorage.getItem(timestampKey);
            const storedVersion = localStorage.getItem(versionKey);

            if (storedData && storedTimestamp && storedVersion === dataVersion && currentTime - parseInt(storedTimestamp) < twentyFourHours) {
                try {
                    loadVariantGalleries(JSON.parse(storedData));
                } catch (e) {
                    console.error("Chyba při parsování dat z localStorage:", e);
                    loadVariantGalleriesFromServer();
                }
            } else {
                loadVariantGalleriesFromServer();
            }

            function loadVariantGalleriesFromServer() {
                $.getJSON("/user/documents/data/variant-galleries.json", function (data) {
                    localStorage.setItem(storageKey, JSON.stringify(data));
                    localStorage.setItem(timestampKey, currentTime.toString());
                    localStorage.setItem(versionKey, dataVersion);
                    loadVariantGalleries(data);
                }).fail(function () {
                    console.error("Chyba při načítání variant-galleries.json ze serveru");
                });
            }
        }

        // Need help box — na mobilu před social buttons, na desktopu pod galerií
        if (shopDataLayer.needHelp && !$(".p-image-wrapper .flag-specialni-galerie").length) {
            const $needHelp = $(window.buildNeedHelpBlock());
            if (window.innerWidth < 768) {
                $needHelp.insertBefore(".social-buttons-wrapper");
            } else {
                $needHelp.appendTo(".p-image-wrapper");
            }
        }

        $(".products-related-header, .products-related").appendTo("#content");

        $(".products-block").each(function (index) {
            $(this)
                .addClass("swiper-wrapper")
                .wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
            $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
            $($(this).find(".product")).addClass("swiper-slide");
            const productSwiper = new Swiper(".myproducts-swiper-" + index, {
                pagination: {
                    el: ".myswiper-navi-" + index + " .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".myswiper-navi-" + index + " .myswiper-next",
                    prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
                },
                spaceBetween: 24,
                slidesPerView: "auto",
                preventClicks: false,
                preventClicksPropagation: false,

                breakpoints: {
                    320: {
                        spaceBetween: 15,
                        slidesOffsetAfter: 10,
                        slidesOffsetBefore: 10,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesOffsetAfter: 0,
                        slidesOffsetBefore: 0,
                    },
                },
            });
        });

        $(".shp-tabs-wrapper.p-detail-tabs-wrapper").insertAfter(".position--benefitProduct");
        $("#p-detail-tabs li[data-testid='tabDescription'] a").html(shopDataLayer.productDetail.descriptionTabText);
        $(".basic-description > h3:first-child").html(shopDataLayer.productDetail.descriptionTitle);
        $(".extended-description > h3:first-child").html(shopDataLayer.productDetail.parametersTitle);
        $(".browse-p").remove();

        $("<h2 class='homepage-group-title h4'>" + shopDataLayer.productDetail.productsAlternativeTitle + "</h2>").prependTo("#productsAlternative");
        $(".products-related-header").addClass("homepage-group-title h4").html(shopDataLayer.productDetail.productsRelatedTitle);
    }

    if ($(".ordering-process").length) {
        $("ol.cart-header .step-2 span").html(shopDataLayer.cart.secondStepText);
    }

    if ($(".id--9").length) {
        $("tr.removeable").each(function () {
            if ($(this).find(".cart-p-image img").attr("data-src").includes("related")) {
                $(this).find(".cart-p-image img").attr("data-src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "big"));
            }
            $(this).find("td.p-availability .availability-label").appendTo($(this).find(".p-name"));

            if ($(window).width() < 992) {
                if ($(this).find(".myprice").length == 0) {
                    $("<div class='myprice'></div>").prependTo($(this).find(".p-total"));
                    $(this).find(".p-price > *").prependTo($(this).find(".p-total .myprice"));
                }
            }
        });

        $(".free-gifts-img img").each(function () {
            if ($(this).attr("data-src").includes("related")) {
                $(this).attr("data-src", myImageSize($(this).attr("data-src"), "big"));
            }
        });

        if ($(".discount-coupon").length) {
            $("#discountCouponCode").attr("placeholder", shopDataLayer.cart.coupon.placeholder);
            $(".discount-coupon button").html(shopDataLayer.cart.coupon.buttonText);
        }

        $(".next-step .next-step-forward").html(shopDataLayer.cart.nextStepButtons.firstStep);
        $(".cart-summary").prependTo(".sidebar-in-cart");
        $(".delivery-time").insertAfter(".extras-wrapper .extras-col:first-child");
    }

    if ($(".id--16").length) {
        $(".next-step #orderFormButton").html(shopDataLayer.cart.nextStepButtons.secondStep);
        $(".co-payment-method > h4.order-payment").html(shopDataLayer.cart.titles.payment);
        $(".co-delivery-method > h4.order-delivery").html(shopDataLayer.cart.titles.delivery);
        $(".cart-header").prependTo(".cart-inner");
    }

    if ($(".id--17").length) {
        $(".next-step #submit-order").html(shopDataLayer.cart.nextStepButtons.thirdStep);
        $(".co-contact-information > h4").html("<span>" + $(".co-contact-information > h4").text() + "</span>");
        $(".co-contact-information label[for='login']").next().find(".btn").html(shopDataLayer.cart.loginBtnText).appendTo(".co-contact-information > h4");
        $(".cart-header").prependTo(".cart-inner");
    }

    $(document).on("click", ".category-perex .read-more", function () {
        $(this).parent().removeClass("not-all");
        $(".category-perex p:not(:first-child)").show();
        $(this).hide();
        $(".category-perex.not-all").removeClass("not-all");
    });

    $(document).on("click", ".filter-section h4", function () {
        $(this).parent().toggleClass("active");
    });

    // Video overlay — přehrát video z mycontact-card__play
    $(document).on("click", ".mycontact-card__play", function () {
        var videoSrc = $(this).attr("data-video-src");
        if (!videoSrc) return;

        var $existing = $(".mypopup-window[data-video='" + videoSrc + "']");

        if ($existing.length) {
            $existing.fadeIn(300);
            $existing.find("video")[0].play();
        } else {
            $("<div class='mypopup-window' data-video='" + videoSrc + "'>" +
                "<div class='clickable-part'></div>" +
                "<div class='mypopup-inner'>" +
                "<div class='close-popup'></div>" +
                "<div class='video-holder'>" +
                "<video controls autoplay><source src='" + videoSrc + "' type='video/mp4'></video>" +
                "</div>" +
                "</div>" +
                "</div>").appendTo("body");

            $(".mypopup-window[data-video='" + videoSrc + "']").fadeIn(300);
        }
    });

    $(document).on("click", ".mypopup-window .close-popup, .mypopup-window .clickable-part", function () {
        const $popup = $(this).closest(".mypopup-window");
        const video = $popup.find("video")[0];
        if (video) video.pause();
        $popup.fadeOut(300);
    });

    // Dekor na kliknutí — otevři celou fotku v popupu (reuse .mypopup-window shell)
    $(document).on("click", ".decor-image", function () {
        const $img = $(this).find("img");
        const src = $img.attr("src");
        if (!src) return;

        const alt = $img.attr("alt") || "";
        const $existing = $(".mypopup-window[data-image='" + src + "']");

        if ($existing.length) {
            $existing.fadeIn(300);
        } else {
            $("<div class='mypopup-window mypopup-window--image' data-image='" + src + "'>" +
                "<div class='clickable-part'></div>" +
                "<div class='mypopup-inner'>" +
                "<div class='close-popup'></div>" +
                "<div class='image-holder'>" +
                "<img src='" + src + "' alt='" + alt + "'>" +
                "</div>" +
                "</div>" +
                "</div>").appendTo("body");

            $(".mypopup-window[data-image='" + src + "']").fadeIn(300);
        }
    });

    initFixedFirmyBtn();

    if ($(".reviews-loader").length) {
        $(
            "<div class='reviews container'><h2 class='reviews-title'>" +
            shopDataLayer.productDetail.reviewsTitle +
            "</h2><div class='reviews-inner'></div><div class='btn-holder'><a href='" +
            shopDataLayer.homepage.reviews.readMore.link +
            "' class='my-btn'>" +
            shopDataLayer.homepage.reviews.readMore.text +
            "</a><a href='" +
            shopDataLayer.homepage.reviews.addReview.link +
            "' class='my-btn main-btn'>" +
            shopDataLayer.homepage.reviews.addReview.text +
            "</a></div></div>",
        ).appendTo(".reviews-loader");
    }

    if ($(".reviews").length > 0) {
        $.get(
            "/cache/hodnoceni-obchodu/",
            function (data) {
                var extractedData = $(data).find(".content-inner > .votes-wrap > .vote-wrap");

                var filteredVotes = extractedData
                    .filter(function () {
                        return $(this).find(".star-on").length == 5 && $(this).find(".vote-content").text().trim().length > 50;
                    })
                    .slice(0, 4);

                filteredVotes.each(function () {
                    $(".reviews-inner").append($(this).clone());
                });
            },
            "html",
        ).done(function () {
            $(".reviews .vote-wrap").each(function () {
                $(this).find(".vote-name").appendTo($(this));
                if ($(this).find(".vote-name span").is(":empty")) {
                    $(this).find(".vote-name span").html(shopDataLayer.homepage.reviews.noName);
                }
            });
        }).always(function () {
            // Když z nových hodnocení neprojde dost recenzí (nebo načtení selže), doplní se záloha
            $(".reviews .reviews-inner").each(function () {
                fillBackupReviews($(this), shopDataLayer.homepage.reviews.backupCount);
            });
        });
    }

    $("#content-wrapper").css("opacity", "1");
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    // Reinit fixního CTA tlačítka (pro případ, že AJAX reload smazal DOM)
    initFixedFirmyBtn();

    if ($(".type-category").length) {
        $(".subcategories").prependTo(".category-content-wrapper");
        if ($(".category-perex p").length > 1 && $(".read-more").length == 0) {
            $(".category-perex").addClass("not-all");
            $("<span class='read-more'>" + shopDataLayer.category.readMore + "</span>").appendTo(".category-perex p:first");
            $(".category-perex p:not(:first-child)").hide();
        }
        $(".filter-section:has(.filter-label.active)").addClass("active");
        $(".load-products").html(shopDataLayer.category.loadMore);
    }

    if ($(".id--9").length) {
        $("tr.removeable").each(function () {
            if ($(this).find(".cart-p-image img").attr("src").includes("related")) {
                $(this).find(".cart-p-image img").attr("src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "big"));
            }
            $(this).find("td.p-availability .availability-label").appendTo($(this).find(".p-name"));

            if ($(window).width() < 992) {
                if ($(this).find(".myprice").length == 0) {
                    $("<div class='myprice'></div>").prependTo($(this).find(".p-total"));
                    $(this).find(".p-price > *").prependTo($(this).find(".p-total .myprice"));
                }
            }
        });

        $(".free-gifts-img img").each(function () {
            if ($(this).attr("data-src").includes("related")) {
                $(this).attr("data-src", myImageSize($(this).attr("data-src"), "big"));
            }
        });

        if ($(".discount-coupon").length) {
            $("#discountCouponCode").attr("placeholder", shopDataLayer.cart.coupon.placeholder);
            $(".discount-coupon button").html(shopDataLayer.cart.coupon.buttonText);
        }

        $(".next-step .next-step-forward").html(shopDataLayer.cart.nextStepButtons.firstStep);
        $(".cart-summary").prependTo(".sidebar-in-cart");
        $(".delivery-time").insertAfter(".extras-wrapper .extras-col:first-child");
    }
});

// Advanced order popup — swiper
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    const $popup = $(".advanced-order");
    if ($popup.length === 0) return;

    // Swiper pro doporučené produkty
    const $productsBlock = $popup.find(".products-block");
    if ($productsBlock.length && $productsBlock.find(".product").length > 0) {
        $productsBlock
            .addClass("swiper-wrapper")
            .wrap("<div class='advanced-order-products-wrap'><div class='swiper advanced-order-swiper'></div></div>");

        $("<div class='myswiper-navi advanced-order-navi'>" +
            "<div class='swiper-button-prev myswiper-prev'></div>" +
            "<div class='swiper-button-next myswiper-next'></div>" +
            "<div class='swiper-pagination'></div>" +
            "</div>").appendTo($popup.find(".advanced-order-products-wrap"));

        $productsBlock.find(".product").addClass("swiper-slide");

        const advancedOrderSwiper = new Swiper(".advanced-order-swiper", {
            pagination: {
                el: ".advanced-order-navi .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".advanced-order-navi .myswiper-next",
                prevEl: ".advanced-order-navi .myswiper-prev",
            },
            spaceBetween: 20,
            slidesPerView: 3,
            simulateTouch: false,

            // Bez těchto dvou parametrů Swiper vytváří ResizeObserver na
            // rodičích (#cboxLoadedContent) → jakákoli změna rozměru colorboxu
            // → Swiper recalc → změna wrapper height → colorbox resize → loop,
            // který se na Windows projeví jako blikající scrollbar každých ~50ms.
            observer: false,
            observeParents: false,

            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                    slidesOffsetAfter: 10,
                    slidesOffsetBefore: 10,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                },
            },
        });

        // Shoptet colorbox změřil popup PŘED Swiper inicializací — teď ho
        // donutíme přeměřit s aktuálním (swiper) layoutem.
        if (typeof shoptet !== "undefined" && shoptet.modal && shoptet.modal.resize) {
            shoptet.modal.resize();
        }
    }
});

var shopDataLayer = {
    header: {
        search: {
            placeholder: "Napište, co hledáte...",
        },
        login: {
            text: "Účet",
        },
        cart: {
            text: "Košík",
        },
        firmy: {
            text: "Vyžádat nabídku pro podnikatele",
        },
        // Hamburger menu: tlačítko nabídky a kontaktní osoba se vkládají nad první nalezenou položku
        mobileMenu: {
            insertBefore: [".menu-item-813", ".menu-item-29"],
        },
    },
    homepage: {
        reviews: {
            title: "Takto nás hodnotíte",
            addReview: {
                text: "Přidat vlastní recenzi",
                link: "/hodnoceni-obchodu",
            },
            readMore: {
                text: "Přečíst další recenze",
                link: "/hodnoceni-obchodu",
            },
            noName: "Hodnocení z Heuréka.cz",
            // Záloha: starší skutečné recenze z /hodnoceni-obchodu/. Doplní blok, když mezi
            // novými hodnoceními není dost pětihvězdičkových s delším textem.
            backupCount: 3,
            backup: [
                {
                    name: "Kamila Frusová",
                    text: "Ráda bych pochválila tento obchod za skvělý nákup kuchyňských dřevěných židlí. Židle jsou krásně zpracované, stabilní a působí opravdu kvalitním dojmem. Dřevo je pečlivě opracované a celkové provedení odpovídá popisu i fotografiím na webu. Oceňuji také rychlé vyřízení objednávky a bezproblémové doručení. Komunikace obchodu byla vstřícná a profesionální. Určitě zde nakoupím znovu.",
                },
                {
                    name: "Ivana Peškova",
                    text: "Nakupovala jsem u vás poprvé židle z masívu ,které jsou pohodlné a ladí s barvou kuchyně,zboži přišlo v krátkém termínu ,v obchotě jsou velmi vstřícní ochotní,židle dobře zabalené všechno v pořádku děkujeme určitě u vás budu ráda nakupovat",
                },
                {
                    name: "Alena Klimesova",
                    text: "Rychlost a kvalita vyrobku. Ve skutečnosti jsou židle ještě hezčí. Krásně zabaleno bez vady.Jsem maximálně spokojená. Určitě tento obchod doporučuji.",
                },
                {
                    name: "Eva Špádová",
                    text: "Super stůl,kvalitní, barva dle výběru přesně taková jako na obrázku. Bytelný, krásný. Rychlá doprava, vše super. Moc spokojená.",
                },
                {
                    name: "Josef Nýč",
                    text: "Nabídka, balení, dodání vše bezvadné, ale zvláště oceňuji chování vašeho pracovníka. Povšiml si rozdílného odstínu barvy stolu a židlí v mé objednávce, vyhledal na skladě židle totožného provedení se stolem a telefonicky mě upozornil. Sjednali jsme opravu objednávky k mé naprosté spokojenosti. Nevídaná vstřícnost k potřebám zákazníka mně ohromila. Vřelé díky a hodně úspěchů.",
                },
                {
                    name: "Miloš Bílý",
                    text: "Kvalitní židle a stoly za rozumnou cenu. Kupoval jsem do gastra a jsem velmi spokojený.",
                },
            ],
        },
    },
    product: {
        detailButton: "Vybrat variantu",
        addToCartButton: "Přidat do košíku",
    },
    availability: {
        shortSeparator: " - ",
    },
    category: {
        readMore: "Celý popisek",
        loadMore: "Načíst další produkty",
    },
    productDetail: {
        autoSelectFirstVariant: true,
        specificBanner: {
            title: "Chcete specifický rozměr?",
            subtitle: "Uděláme vám cenovou nabídku.",
            button: {
                text: "Poptat rozměr",
            },
            image: "/user/documents/upload/kodovani/specific-bg.jpg",
        },
        longDecsriptionLinkText: "Detailní popis",
        askText: "Dotaz na produkt",
        watchdogText: "Hlídat cenu",
        reviewsTitle: "Hodnocení našich zákazníků",
        productsRelatedTitle: "Mohlo by se vám líbit",
        productsAlternativeTitle: "S námi se prodávají",
        descriptionTabText: "Podrobnosti",
        descriptionTitle: "O produktu",
        parametersTitle: "Parametry",
        ratingTitle: "Hodnocení produktu",
    },
    modal: {
        rozmer: {
            title: "Potřebujete jiný rozměr <br>nebo úpravu na míru?",
            subtitle: "Napište nám svou představu. Do 24 hodin se vám ozveme<br>s cenou a termínem dodání.",
            formTag: "[w-form-2ZE8S]",
            success: {
                title: "Děkujeme, budeme vás kontaktovat <br>do 24 hodin.",
                text: "<p>Pokud nám bude cokoli nejasného, ozveme se vám na zadaný telefon a doptáme se vám na podrobnosti.</p><p><strong>Tým ŽidleStoly.cz</strong></p>",
                image: "/user/documents/upload/kodovani/team-ZS.jpg",
                buttonText: "Pokračovat na web",
            },
        },
        firmy: {
            title: "Zařizujete prostor <br>a přejete si nabídku?",
            subtitle: "Prosím vyplňte formulář a my připravíme cenovou nabídku. <br>Tipy na detaily, které nás zajímají: <ul><li>jaký prostor vybavujete</li><li>počet židlí a stolů a jejich specifikace</li><li>termín realizace</li></ul>",
            formTag: "[w-form-MZDSX]",
            success: {
                title: "Děkujeme, budeme vás kontaktovat <br>do 24 hodin.",
                text: "<p>Pokud nám bude cokoli nejasného, ozveme se vám na zadaný telefon a doptáme se vám na podrobnosti.</p><p><strong>Tým ŽidleStoly.cz</strong></p>",
                image: "/user/documents/upload/kodovani/team-ZS.jpg",
                buttonText: "Pokračovat na web",
            },
        },
    },
    needHelp: {
        title: "Potřebujete poradit?",
        person: {
            name: "Tomáš Liška",
            statusOnline: "Právě online",
            statusOffline: "Offline",
            onlineFrom: [9, 0],
            onlineTo: [16, 0],
            image: "/user/documents/upload/kodovani/tomas.png",
        },
        phone: {
            number: "+420 800 228 288",
            link: "tel:+420800228288",
            hours: "(Po-Pá, 9-17)",
        },
        email: {
            address: "prodejna@zidlestoly.cz",
            link: "mailto:prodejna@zidlestoly.cz",
            note: "Odpovídáme do 24 hodin",
        },
    },
    cart: {
        giftTitle: "Dárek k nákupu",
        coupon: {
            placeholder: "Vložte slevový kupón",
            buttonText: "Použít",
        },
        nextStepButtons: {
            firstStep: "Pokračovat na doručení",
            secondStep: "Pokračovat na kontakt",
            thirdStep: "Odeslat objednávku a zaplatit",
        },
        loginBtnText: "Mám účet, přihlásit se",
        titles: {
            delivery: "Doprava",
            payment: "Platba",
        },
        secondStepText: "Doručení a platba",
    },
    headerContact: {
        enabled: true,
        photo: "/user/documents/upload/kodovani/tomas.png",
        name: "Tomáš Liška",
        role: "",
        phone: {
            text: "+420 800 228 288",
            link: "tel:+420800228288",
        },
        hoursText: "(Po-Pá, 9-17)",
        // Rozvrh v pražském čase: 0 = neděle, 1 = pondělí … 6 = sobota; null = celý den offline
        schedule: {
            1: ["09:00", "17:00"],
            2: ["09:00", "17:00"],
            3: ["09:00", "17:00"],
            4: ["09:00", "17:00"],
            5: ["09:00", "17:00"],
            6: null,
            0: null,
        },
        statusOnline: "online",
        statusOffline: "offline",
    },
    advancedOrderRelated: {
        enabled: true,
    },
    cartTip: {
        title: "Dýško pro náš tým",
        subtitle: "Podpoříte zaměstnance rodinné firmy? Peníze spravedlivě utratíme za náš firemní večírek.",
        removeTitle: "Kliknutím dýško zrušíte",
        options: [
            {
                code: "8757",
                label: "Přidat 10 Kč",
                activeLabel: "Přidáno 10 Kč",
                image: "/user/documents/upload/kodovani/10kc.png",
            },
            {
                code: "8758",
                label: "Přidat 20 Kč",
                activeLabel: "Přidáno 20 Kč",
                image: "/user/documents/upload/kodovani/20kc.png",
            },
            {
                code: "8759",
                label: "Přidat 50 Kč",
                activeLabel: "Přidáno 50 Kč",
                image: "/user/documents/upload/kodovani/50kc.png",
            },
            {
                code: "7212",
                label: "Přidat 100 Kč",
                activeLabel: "Přidáno 100 Kč",
                image: "/user/documents/upload/kodovani/100kc.png",
            },
        ],
    },
    blogListing: {
        readMoreButton: "Pokračovat ve čtení",
        longDate: true,
        loadMore: {
            enabled: true,
            text: "Načíst další články",
        },
    },
    realizace: {
        gallery: {
            autoHeight: true,
        },
        reviews: {
            enabled: true,
            title: "Takto nás hodnotíte",
            loadingText: "Načítáme hodnocení…",
            count: 3,
            minTextLength: 50,
        },
    },
    flagsFilter: {
        title: "Příznak",
        // Ve filtru jen tyto příznaky (1 = Akce), ostatní se schovají
        visibleIds: [1],
        defaultColor: "#1e9200",
        stockColor: "#1e9200",
        flags: {
            1: { name: "Pouze akční produkty", color: "#a61a33" },
            2: { color: "#3a800e" },
            355: { color: "#5a0085" },
            358: { color: "#3f5541" },
            372: { color: "#a61a33" },
        },
    },
    blogArticle: {
        toc: {
            title: "Obsah článku",
            minHeadings: 2,
        },
        products: {
            hiddenFlags: ["flag-specialni-galerie", "flag-specificky-rozmer"],
        },
        term: {
            label: "Slovníček pojmů",
            buttonText: "Zobrazit celý pojem",
        },
        glossary: {
            linkText: "Více o pojmu",
        },
        faq: {
            structuredData: true,
        },
        table: {
            scrollHint: "Tabulku posunete prstem do strany",
        },
        updated: {
            enabled: true,
            text: "Aktualizováno",
        },
        author: {
            enabled: true,
            label: "Autor:",
            name: "Michael Rufer",
        },
    },
    glossaryListing: {
        enabled: true,
        allLettersText: "Vše",
        maxRequests: 4,
        timeout: 10000,
    },
};
window.shopDataLayer = shopDataLayer;

// Sdílený builder pro need-help blok
window.buildNeedHelpBlock = function (modifier) {
    var nh = shopDataLayer.needHelp;
    if (!nh) return "";
    var cls = modifier ? "need-help " + modifier : "need-help need-help--inline";
    var now = new Date();
    var mins = now.getHours() * 60 + now.getMinutes();
    var from = nh.person.onlineFrom[0] * 60 + nh.person.onlineFrom[1];
    var to = nh.person.onlineTo[0] * 60 + nh.person.onlineTo[1];
    var isOnline = mins >= from && mins < to;
    var statusText = isOnline ? nh.person.statusOnline : nh.person.statusOffline;
    var statusCls = "need-help__status" + (isOnline ? "" : " need-help__status--offline");
    return (
        "<div class='" + cls + "'>" +
        "<div class='need-help__title'>" + nh.title + "</div>" +
        "<div class='need-help__items'>" +
        "<div class='need-help__item'>" +
        "<img src='" + nh.person.image + "' alt='" + nh.person.name + "' class='need-help__avatar'>" +
        "<div class='need-help__info'>" +
        "<strong class='need-help__name'>" + nh.person.name + "</strong>" +
        "<span class='" + statusCls + "'><span class='need-help__status-dot'></span>" + statusText + "</span>" +
        "</div>" +
        "</div>" +
        "<div class='need-help__item'>" +
        "<div class='need-help__icon need-help__icon--phone'></div>" +
        "<div class='need-help__info'>" +
        "<a href='" + nh.phone.link + "' class='need-help__link'>" + nh.phone.number + "</a>" +
        "<span class='need-help__note'>" + nh.phone.hours + "</span>" +
        "</div>" +
        "</div>" +
        "<div class='need-help__item'>" +
        "<div class='need-help__icon need-help__icon--mail'></div>" +
        "<div class='need-help__info'>" +
        "<a href='" + nh.email.link + "' class='need-help__link'>" + nh.email.address + "</a>" +
        "<span class='need-help__note'>" + nh.email.note + "</span>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>"
    );
};
